<template>
<b-row>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters['callDateTime[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters['callDateTime[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmcalllog.list.answered') }}:</label>
    <b-form-group>
      <b-form-radio-group
        v-model="filters.answered"
        :options="radioOptionsAnswered"
        buttons
        button-variant="outline-primary"
        name="radios-btn-default"
      ></b-form-radio-group>
    </b-form-group>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmcalllog.list.callDirection') }}:</label>
    <b-form-group>
      <b-form-radio-group
        v-model="filters.callDirection"
        :options="radioOptionsDirection"
        buttons
        button-variant="outline-primary"
        name="radios-btn-default"
      ></b-form-radio-group>
    </b-form-group>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmcalllog.list.phoneNumber') }}:</label>
    <input v-model.lazy="filters.phoneNumber" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.excmcalllog.list.phoneNumber')"/>
  </b-col>
  <b-col sm="6" md="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.excmcalllog.list.idHandlingUserData') }}:</label><br>
      <base-select-input
        v-model="filters.idHandlingUserData"
        :search-callback="getSalesRepresentativesCallback"
        :display-values="['fullName']"
        :query-param="'userdata'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col sm="6" md="3">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.excmcalllog.list.idRelatedUserData') }}:</label><br>
      <base-select-input
        v-model="filters.idRelatedUserData"
        :search-callback="userDataSearchCallback"
        :display-values="['fullName', 'firmname1']"
        :query-param="'userdata'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col sm="6" md="3" v-if="!callLogRelatedContractorFilter">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.financialreport.list.contractor') }}:</label><br>
      <base-select-input
        v-model="filters.callLogRelatedContractorFilter"
        :search-callback="userDataSearchCallback"
        :display-values="['fullName', 'firmname1']"
        :query-param="'userdata'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
</b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'CallLogFiltering',
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  directives: {
    debounce
  },
  props: {
    callLogRelatedContractorFilter: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filtersReference: {},
      delay: 500,
      radioOptionsDirection: [
        {
          value: [1, 0],
          text: this.$t('menu.agreements.listAll')
        },
        {
          value: 1,
          text: this.$t('views.excmcalllog.list.callDirectionOutbound')
        },
        {
          value: 0,
          text: this.$t('views.excmcalllog.list.callDirectionInbound')
        }
      ],
      radioOptionsAnswered: [
        {
          value: [1, 0],
          text: this.$t('menu.agreements.listAll')
        },
        {
          value: 1,
          text: this.$t('views.promotions.form.yes')
        },
        {
          value: 0,
          text: this.$t('views.promotions.form.no')
        }
      ],
      filters: {
        answered: [1, 0],
        callDirection: [1, 0],
        'callDateTime[after]': '',
        'callDateTime[before]': '',
        phoneNumber: '',
        idHandlingUserData: '',
        idRelatedUserData: '',
        callLogRelatedContractorFilter: this.callLogRelatedContractorFilter
      }
    }
  },
  created () {
    this.filtersReference = JSON.parse(JSON.stringify(this.filters))
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_c_m_call_logs'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    clearFilters () {
      this.filters = JSON.parse(JSON.stringify(this.filtersReference))
    },
    async getSalesRepresentativesCallback (params = {}) {
      let baseParams = { pagination: false, idClientType: 4 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  }
}

</script>

<style scoped>

</style>
